import React, { Fragment } from 'react';
import Appointment from '../../components/Appointment/Appointment';
// import BlogSection from '../../components/BlogSection/BlogSection';
import Features from '../../components/Features/Features';
import Footer from '../../components/footer/Footer';
import FunFact2 from '../../components/FunFact2/FunFact2';
import Hero2 from '../../components/hero2/hero2';
import Navbar from '../../components/Navbar/Navbar';
// import ProjectSection from '../../components/ProjectSection/ProjectSection';
import Scrollbar from '../../components/scrollbar/scrollbar';
import WhyChooseUs from '../../components/WhyChooseUs/WhyChooseUs';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
// import ServiceSection2 from '../../components/ServiceSection2/ServiceSection2';
// import TeamSection from '../../components/TeamSection/TeamSection';
import Testimonial from '../../components/Testimonial/Testimonial';
import Logo from '../../images/logo.png';
import SEO from '../../components/SEO/SEO';
import { seoData } from '../../utils/seoData';



const HomePage2 = () => {

    return (
        <Fragment>
            <SEO title={seoData.home.title} description={seoData.home.description} keywords={seoData.home.keywords} />
            <Navbar topbarBlock={'wpo-header-style-2'} Logo={Logo} />
            <Hero2 />
            <Features fClass={'wpo-features-section-s2'}/>
            <Appointment />
            <div style={{paddingTop: '80px'}}>
                <WhyChooseUs/>
            </div>
            {/* <ServiceSection2 /> */}
            <FunFact2 />
            <ServiceSection />
            {/* <ProjectSection /> */}
            {/* <TeamSection /> */}
            <Testimonial />
            {/* <BlogSection /> */}
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default HomePage2;